import { render, staticRenderFns } from "./SFormPurchaseComp.vue?vue&type=template&id=4be1d99a&"
import script from "./SFormPurchaseComp.vue?vue&type=script&lang=js&"
export * from "./SFormPurchaseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports